import { MatLegacySnackBarConfig as MatSnackBarConfig } from '@angular/material/legacy-snack-bar';

export const matSnackBarConfig: MatSnackBarConfig = {
  duration: 5_000,
};
